<template>
  <actors url="actors"></actors>
</template>
<script>
import actors from './components/people'
export default {
  components: {
    actors
  }
}
</script>
<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/movie/actors.vue